import React, {Component} from 'react'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.content = React.createRef();
    this.state = {
      setActive: false,
      setHeight: "0px",
    };
  }

  static defaultProps = {
    content: '',
    title: ''
  }
  
  static propTypes = {
    content: PropTypes.string,
    title: PropTypes.string
  }

  toggleAccordion() {
    if (!this.state.setActive) {
        this.setState({ setActive: !this.state.setActive})
        this.setState({ setHeight: `${this.content.current.scrollHeight}px` })
      } else {
        this.setState({ setHeight: "0px" })
        this.setState({ setActive: !this.state.setActive })
      }
  }

  customButtons(){
    const {customButtons} = this.props
    if (customButtons) {
     return <span className='icon' > { ( this.state.setActive ) ? <img src={customButtons.minus}/> : <img src={customButtons.plus} /> } </span> 
    } else {
      return <span className='icon' > { ( this.state.setActive ) ? '-' : '+' } </span>
    }
  }

  render() {
    return (
      <Wrapper>
        <div className='accordion__section' onClick={() => this.toggleAccordion()} >
          <a className={`accordion ${this.state.setActive}`} >
            <span dangerouslySetInnerHTML={{__html: this.props.title}} className='accordion__title'></span>
            {this.customButtons()}
          </a>
          <div ref={this.content} className='accordion__content' style={{maxHeight: `${this.state.setHeight}`}}>
            <div className='accordion__text' dangerouslySetInnerHTML={{__html: this.props.content}}/>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default Accordion;
